// extracted by mini-css-extract-plugin
module.exports = {"excelButton":"index_excelButton_1V6Dc"};